import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {BasePageComponent} from "../../base-page.component";
import {RegistrationService} from "../../services/domain/registration.service";
import {NgForm} from "@angular/forms";
import {RegistrationRequest} from "../../models/registrazione.models";
import {PlaceService} from "../../services/domain/place.service";
import {ComuniDto} from "../../models/comuni.models";
import {HttpService} from "../../services/http.service";
import {UtilsService} from "../../services/utils.service";
import {ConfirmationService} from "primeng/api";
import {DocumentService} from "../../services/domain/document.service";
import {WorkService} from "../../services/domain/work.service";
import {MansioniDto} from "../../models/lavoro.models";
import {AnagraficaUtenteLavoroDesideratoDto, ProfiloPreferenze} from "../../models/preferenze.models";
import {PreferencesService} from "../../services/domain/preferences.service";


@Component({
  selector: 'app-registration',
  templateUrl: './registration.component.html',
  styleUrls: ['./registration.component.css'],
  providers : [PlaceService, WorkService]
})
export class RegistrationComponent extends BasePageComponent  implements OnInit{

  constructor(private registrationService : RegistrationService,
              private placeService : PlaceService,
              private workService : WorkService) {
    super();
  }

  public registrationModel : RegistrationRequest = new RegistrationRequest();
  @ViewChild('registrationForm') registrationForm!: NgForm;
  @ViewChild('profileCv') profileCv!: ElementRef<HTMLInputElement>;

  public submittedPage = false;
  public comuniList : ComuniDto[] = [];
  public comuneNascitaSelezionato : ComuniDto = new ComuniDto();
  public comuneResidenzaSelezionato : ComuniDto = new ComuniDto();
  public baseImagePath : string = "";
  public mostraPulsante: boolean = true;
  public fileCV! : File;
  public taskList : MansioniDto[] = [];
  public lstLavoroDesiderato : AnagraficaUtenteLavoroDesideratoDto[] = [];
  public cvLoaded : boolean = false;


  ngOnInit(): void {
    this.baseImagePath = this.authService.baseImagePath;
  }
  public onBasicUpload(event: Event): void {
    const input = event.target as HTMLInputElement;

    if (!input.files || input.files.length === 0) {
      return;
    }

    const file = input.files[0];

    if (file.type !== 'application/pdf') {
      this.showError('Caricare un file PDF');
      input.value = '';
      return;
    }
    this.fileCV = file;
    this.cvLoaded = true;
  }

  public openCvFilePicker(): void {
    this.profileCv.nativeElement.click();
  }

  public getComuniAutoComplete(event : any){
    if(event == null)
      return;
    if(event.query.length < 3)
      return;

    this.asyncCall(() => this.placeService.getPlaceAutocomplete(event.query), response => {
      this.comuniList = response.Items || [];
    });
  }
  public SignUp(){

    if(this.registrationModel.privacyCheck == false || this.registrationModel.privacyCheck == null)
      return this.showWarning("Per procedere accettare condizioni d'uso e normative privacy");

    if(this.registrationModel.Password == null || this.registrationModel.Password == '')
      return this.showError("Inserire password");

    if(this.registrationModel.Password != this.registrationModel.confirmPassword)
      return this.showError("Le due password non coincidono");

    if(this.registrationModel.Email == null || this.registrationModel.Email == '')
      return this.showError("Inserire email");

    if(this.registrationModel.Email.toUpperCase() != this.registrationModel.confirmEmail.toUpperCase())
      return this.showError("Le due email non coincidono");

    if(this.comuneNascitaSelezionato.IdComune != 0)
      this.registrationModel.IdComuneNascita = this.comuneNascitaSelezionato.IdComune;

    if(this.comuneResidenzaSelezionato.IdComune != 0)
      this.registrationModel.IdComuneResidenza = this.comuneResidenzaSelezionato.IdComune;
    else
      return this.showError("Inserire comune di residenza");

    if(this.registrationModel.Cellulare == null || this.registrationModel.Cellulare == '')
      return this.showError("Inserire cellulare");

    if(this.fileCV == null || this.fileCV.length <= 0)
      return this.showError("Inserire Curriculum Vitae");

    this.setDataBeforeSave();


    this.registrationModel.MansioniPreferenzeList = (this.lstLavoroDesiderato ?? []).map(x => x.IdMansione).join(',');

    const fd = new FormData();
    fd.append('modelString', JSON.stringify(this.registrationModel));
    fd.append('file', this.fileCV, this.fileCV.name);

    this.asyncCall(() => this.registrationService.newCandidateRegistration(fd), response => {
      setTimeout(() => {
        this.registrationService.registrationCompleted$.next(null);
      }, 100)
      this.navigate(['/signin']);
    });
  }

  public getMansioni(event : any){
    // if(this.lstLavoroDesiderato.length == 3)
    //   return this.showWarning("Puoi selezionare fino a 3 Mansioni");

    if(event.query.length < 3)
      return;

    this.asyncCall(() => this.workService.getTaskAutocomplete(event.query), response => {
      this.taskList = response.Items || [];
      for( let j = 0; j < this.lstLavoroDesiderato.length; j++){
        this.taskList = this.taskList.filter(x => x.IdMansione != this.lstLavoroDesiderato[j].IdMansione);
      }
    });

  }


  private setDataBeforeSave(){
    if(this.registrationModel.DataNascita != null)
      this.registrationModel.DataNascita = UtilsService.ConvertDateToTimeZoneIta(this.registrationModel.DataNascita);
  }
}
